import { useState } from 'react';
import { Grid, Popover, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import CustomToolbar from '../helpers/customToolbar';
import useStore from '../zustand/useStore';
const ListView = () => {
  // Set Local state
  const [popoverState, setPopoverState] = useState({
    anchor: null,
    content: null,
  });

  // Get global State slices
  const { gridData, gridOptions, loading } = useStore((state) => ({
    gridData: state.MUIdata,
    gridOptions: state.gridOptions,
    loading: state.loading,
  }));

  // Popover functions
  const handlePopoverOpen = (event) => {
    const field = event.currentTarget.dataset.field;
    const id = event.currentTarget.parentElement.dataset.id;
    const row = gridData.rows.find((r) => String(r.id) === id);
    if (field !== 'picture' && row[field] !== undefined && row[field] !== '') {
      setPopoverState({ content: row[field], anchor: event.currentTarget });
    }
  };

  const handlePopoverClose = () => {
    setPopoverState({ anchor: null });
  };

  const open = Boolean(popoverState.anchor);

  return (
    <>
      <Grid container style={{ width: '100%', margin: '3rem auto 0' }}>
        <Grid item xs={12}>
          <DataGrid
            columns={gridData.columns}
            rows={gridData.rows}
            rowHeight={gridOptions.rowHeight}
            autoHeight={true}
            components={{ Toolbar: CustomToolbar }}
            loading={false}
            componentsProps={{
              cell: {
                onMouseEnter: handlePopoverOpen,
                onMouseLeave: handlePopoverClose,
              },
            }}
          />
        </Grid>
      </Grid>
      <Popover
        sx={{
          pointerEvents: 'none',
        }}
        open={open}
        anchorEl={popoverState.anchor}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography sx={{ p: 2, fontSize: '0.75rem', bgcolor: '#dedede' }}>
          {popoverState.content}
        </Typography>
      </Popover>
    </>
  );
};

export default ListView;
